export var inBrowser = typeof window !== 'undefined';
export var UA = inBrowser && window.navigator.userAgent.toLowerCase();
export var isIE = UA && /msie|trident/.test(UA);
export var isIE9 = UA && UA.indexOf('msie 9.0') > 0;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/_util/env.js
// module id = null
// module chunks = 